import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Grid, MenuItem, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";

import Constants from "Helpers/Constants";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

const selectFieldProps = {
  InputLabelProps: { shrink: true },
  sx: {
    "& .MuiOutlinedInput-root": {
      minHeight: 56,
      alignItems: "center",
    },
  },
};

function AddExamList() {
  const [redirect, setRedirect] = useState(false);
  const [notification, setNotification] = useState({ open: false, color: "success", message: "" });
  const [allExams, setAllExams] = useState([]);
  const [allYears, setAllYears] = useState([]);
  const [form, setForm] = useState({
    exam_id: "",
    year_id: "",
    exam_name: "",
    number_of_questions: 0,
    shift: "",
    cutoff: "",
    status: "inactive",
  });

  const showMessage = (message, color = "success", shouldRedirect = false) => {
    setNotification({ open: true, color, message });
    setTimeout(() => {
      setNotification({ open: false, color, message: "" });
      if (shouldRedirect) setRedirect(true);
    }, 2500);
  };

  useEffect(() => {
    const loadOptions = async () => {
      try {
        const [examResp, yearResp] = await Promise.all([
          axios.get(Constants.getUrls.getPyqMetaExams),
          axios.get(Constants.getUrls.getPyqMetaYears),
        ]);
        setAllExams(examResp?.data?.data || []);
        setAllYears(yearResp?.data?.data || []);
      } catch (error) {
        showMessage("Unable to load exam or year options.", "error");
      }
    };

    loadOptions();
  }, []);

  const handleChange = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(Constants.postUrls.createExamList, form);
      showMessage("Exam list created successfully!", "success", true);
    } catch (error) {
      showMessage(error?.response?.data?.message || "Unable to create exam list.", "error");
    }
  };

  if (redirect) return <Navigate to="/exam-lists" />;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
            <MDTypography variant="h6" color="white">
              Create Exam List
            </MDTypography>
          </MDBox>
          <MDBox py={3} px={2}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    fullWidth
                    label="Exam"
                    value={form.exam_id}
                    onChange={(e) => handleChange("exam_id", e.target.value)}
                    {...selectFieldProps}
                  >
                    <MenuItem value="">Select Exam</MenuItem>
                    {allExams.map((item) => (
                      <MenuItem key={item._id} value={item._id}>{item.exam_name}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    fullWidth
                    label="Year"
                    value={form.year_id}
                    onChange={(e) => handleChange("year_id", e.target.value)}
                    {...selectFieldProps}
                  >
                    <MenuItem value="">Select Year</MenuItem>
                    {allYears.map((item) => (
                      <MenuItem key={item._id} value={item._id}>{item.year}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Exam Name"
                    value={form.exam_name}
                    onChange={(e) => handleChange("exam_name", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    type="number"
                    fullWidth
                    label="Number of Questions"
                    value={form.number_of_questions}
                    onChange={(e) => handleChange("number_of_questions", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Shift"
                    value={form.shift}
                    onChange={(e) => handleChange("shift", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Cutoff (Optional)"
                    value={form.cutoff}
                    onChange={(e) => handleChange("cutoff", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    fullWidth
                    label="Status"
                    value={form.status}
                    onChange={(e) => handleChange("status", e.target.value)}
                    {...selectFieldProps}
                  >
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="inactive">Inactive</MenuItem>
                    <MenuItem value="active_for_admin">Active For Admin</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
              <Grid align="left" mt={2}>
                <MDButton variant="contained" size="small" color="info" type="submit">
                  Create
                </MDButton>
              </Grid>
            </form>
          </MDBox>
          <MDSnackbar
            color={notification.color}
            icon="notifications"
            title="AgriQuiz"
            content={notification.message}
            dateTime="Just now"
            open={notification.open}
          />
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default AddExamList;
